import type { ApiClient } from '../api.js';
import { ApiCrashReporter, type ApiCrashReporterOptions } from './api.js';
import { SentryReporter, type SentryConfig } from './sentry.js';
import { teeReporter, type CrashReporter } from './types.js';

export * from './types.js';
export * from './api.js';
export * from './sentry.js';
export * from './handlers.js';

/** Console + API always; Sentry only when a DSN is configured. */
export function createCrashReporter(o: Omit<ApiCrashReporterOptions, 'api'> & { api: ApiClient; sentry?: Omit<SentryConfig, 'release'> | null }): CrashReporter {
  const api = new ApiCrashReporter(o);
  return o.sentry?.dsn ? teeReporter(api, new SentryReporter({ ...o.sentry, ...(o.release ? { release: o.release } : {}) })) : api;
}
